import React, { memo } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import classNames from 'classnames';

import { SortableItem } from '../../../decorators/SortableItem';
import { ContactLabel } from '../ContactLabel';

import style from './style.module.css';

const SortableListItem = SortableItem(ContactLabel);

const SortableListComponent = SortableContainer(
  ({ items, onClick, onDelete, opened, entityId, disabled, contacts }) => {
    const labels = items.map((contactJS, i) => {
      const indexInRedux = contacts.findIndex(contact => contact.get('id') === contactJS.id);
      const contact = indexInRedux === -1 ? undefined : contacts.get(indexInRedux);

      return (
        <SortableListItem
          key={contactJS.id}
          childProps={{
            onClick: event => onClick(event, indexInRedux),
            contact,
            onDelete,
            isOpen: indexInRedux === opened,
            entityId,
          }}
          disabled={disabled}
          index={i}
        />
      );
    });

    return <ul className={classNames(style.host, 'nav nav-pills nav-stacked list')}>{labels}</ul>;
  },
);

/** Sortable list component. */
export const SortableList = memo(SortableListComponent);
